export const IncomingMissbellIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      fill="none"
      viewBox="0 0 30 30"
    >
      <circle cx="15" cy="15" r="15" fill="#F05533"></circle>
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M17.25 9v3.75m0 0H21m-3.75 0 4.5-4.5m-8.08 8.147a11 11 0 0 1-2.135-3.007 1.3 1.3 0 0 1-.084-.2.78.78 0 0 1 .11-.646c.036-.05.079-.093.164-.179.263-.262.394-.393.48-.525a1.5 1.5 0 0 0 0-1.635c-.086-.132-.217-.263-.48-.525l-.146-.146c-.398-.4-.598-.598-.812-.707a1.5 1.5 0 0 0-1.354 0c-.214.109-.413.308-.812.707l-.118.118c-.397.397-.596.596-.747.866-.169.3-.29.765-.289 1.108.001.31.061.522.181.945a14.3 14.3 0 0 0 3.656 6.213 14.3 14.3 0 0 0 6.212 3.655c.424.12.635.18.945.181.344.001.809-.12 1.109-.288.27-.152.468-.35.866-.748l.118-.118c.398-.399.598-.598.706-.812a1.5 1.5 0 0 0 0-1.354c-.108-.214-.308-.413-.706-.812l-.146-.146c-.263-.262-.394-.393-.526-.48a1.5 1.5 0 0 0-1.635 0c-.132.087-.263.218-.525.48a1.5 1.5 0 0 1-.179.164.78.78 0 0 1-.646.11 1.3 1.3 0 0 1-.2-.084 11 11 0 0 1-3.007-2.135"
      ></path>
    </svg>
  );
};

export const OutgoingCallIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      fill="none"
      viewBox="0 0 30 30"
    >
      <circle cx="15" cy="15" r="15" fill="#2460B8"></circle>
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M11.535 13.39a11 11 0 0 0 2.135 3.007 11 11 0 0 0 3.007 2.135c.094.045.14.067.2.085.21.061.468.017.646-.11a1.5 1.5 0 0 0 .179-.165c.262-.262.393-.393.525-.479a1.5 1.5 0 0 1 1.636 0c.131.086.262.217.525.479l.146.146c.398.399.598.598.706.812a1.5 1.5 0 0 1 0 1.354c-.108.214-.308.413-.706.812l-.118.118c-.398.398-.596.596-.866.748-.3.168-.765.29-1.109.288-.31 0-.521-.06-.945-.181a14.3 14.3 0 0 1-6.212-3.655 14.3 14.3 0 0 1-3.656-6.213c-.12-.423-.18-.635-.18-.945-.002-.343.12-.809.288-1.108.151-.27.35-.469.747-.866l.118-.118c.399-.399.598-.598.812-.707a1.5 1.5 0 0 1 1.354 0c.214.109.414.308.812.707l.146.146c.263.262.394.393.48.525a1.5 1.5 0 0 1 0 1.635c-.086.132-.217.263-.48.525-.085.086-.128.129-.164.179a.78.78 0 0 0-.11.647c.017.059.04.105.084.199M21.75 12V8.25m0 0H18m3.75 0-4.5 4.5"
      ></path>
    </svg>
  );
};

export const IncomingCallIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      fill="none"
      viewBox="0 0 30 30"
    >
      <circle cx="15" cy="15" r="15" fill="#2460B8"></circle>
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M17.25 9v3.75m0 0H21m-3.75 0 4.5-4.5m-8.08 8.147a11 11 0 0 1-2.135-3.007 1.3 1.3 0 0 1-.084-.2.78.78 0 0 1 .11-.646c.036-.05.079-.093.164-.179.263-.262.394-.393.48-.525a1.5 1.5 0 0 0 0-1.635c-.086-.132-.217-.263-.48-.525l-.146-.146c-.398-.4-.598-.598-.812-.707a1.5 1.5 0 0 0-1.354 0c-.214.109-.413.308-.812.707l-.118.118c-.397.397-.596.596-.747.866-.169.3-.29.765-.289 1.108.001.31.061.522.181.945a14.3 14.3 0 0 0 3.656 6.213 14.3 14.3 0 0 0 6.212 3.655c.424.12.635.18.945.181.344.001.809-.12 1.109-.288.27-.152.468-.35.866-.748l.118-.118c.398-.399.598-.598.706-.812a1.5 1.5 0 0 0 0-1.354c-.108-.214-.308-.413-.706-.812l-.146-.146c-.263-.262-.394-.393-.526-.48a1.5 1.5 0 0 0-1.635 0c-.132.087-.263.218-.525.48a1.5 1.5 0 0 1-.179.164.78.78 0 0 1-.646.11 1.3 1.3 0 0 1-.2-.084 11 11 0 0 1-3.007-2.135"
      ></path>
    </svg>
  );
};

export const ReturnedCallIcon = () => {
  return (
    <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    fill="none"
    viewBox="0 0 32 32"
  >
    <rect width="32" height="32" fill="#2460B8" rx="16"></rect>
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="M12.92 14.569a9.7 9.7 0 0 0 1.898 2.673 9.7 9.7 0 0 0 2.673 1.898c.083.04.125.06.177.075a.7.7 0 0 0 .575-.098c.044-.032.083-.07.159-.146.233-.233.35-.35.466-.426a1.33 1.33 0 0 1 1.454 0c.117.076.234.192.467.425l.13.13c.354.355.531.532.628.722.19.379.19.825 0 1.204-.097.19-.274.367-.628.721l-.105.105c-.353.354-.53.53-.77.665-.266.15-.68.257-.985.256-.276 0-.464-.054-.84-.16a12.7 12.7 0 0 1-5.523-3.25 12.7 12.7 0 0 1-3.249-5.522c-.106-.377-.16-.565-.16-.84-.002-.305.106-.72.256-.985.134-.24.311-.417.664-.77l.105-.105c.354-.354.532-.532.722-.628a1.33 1.33 0 0 1 1.204 0c.19.096.367.274.721.628l.13.13c.233.233.35.35.426.466a1.33 1.33 0 0 1 0 1.454c-.076.117-.193.234-.426.467a1.3 1.3 0 0 0-.146.159.7.7 0 0 0-.098.575c.015.052.035.094.075.177M19.25 14.313a2.062 2.062 0 1 0-1.459-3.52c-.373.373-.833.999-.833.999m0 0v-1.375m0 1.375h1.375"
    ></path>
  </svg>
  );
};